import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { withAppStoreValue, ITopToursCategory } from '../../../../store';

interface ISelectedTopCategoryNameProps {
    selectedTopCategory: ITopToursCategory
}

export default withAppStoreValue<ISelectedTopCategoryNameProps>(memo(({ selectedTopCategory } : ISelectedTopCategoryNameProps) => {
    const { t } = useTranslation()
    return selectedTopCategory && t(selectedTopCategory.name)
}), ['categories.selectedTopCategory'])